;(function () {
  angular.module('contrast.filters').filter('searchfilter', function () {
    return function (input, query) {
      return input.replace(
        RegExp('(' + query + ')', 'i'),
        '<span class="highlight-class">$1</span>'
      )
    }
  })
})()
